import React from 'react';

import agentValuationSvg from 'public/assets/homepage/Illustration_valuation.svg';
import {
    AgentValuationButton,
    Description,
    Heading,
    Image,
    MainContent,
    Wrapper
} from './AgentValuation.styles';
import { trackAgentValuationCTA } from './AgentValuation.tracking';
import { MAIN_SITE_LINK } from '../../../constants';
import { redirect } from '../../../shared/helpers';

const headlineText = 'See what local agents think your home is worth';
const descriptionText =
    'Arrange for local estate agents to value your home for free. No strings attached.';
const agentValuationCta = 'Get a free agent valuation';

export const AgentValuation = () => {
    const discoverLink = `${MAIN_SITE_LINK}/valuation/`;
    const buildAgentValuationLink = () => {
        redirect(discoverLink);
    };

    return (
        <>
            <Wrapper
                onClick={() => {
                    trackAgentValuationCTA();
                    buildAgentValuationLink();
                }}
            >
                <Image src={agentValuationSvg} alt="" />
                <MainContent>
                    <Heading size="4">{headlineText}</Heading>
                    <Description>{descriptionText}</Description>
                    <AgentValuationButton
                        variant="secondary"
                        data-testid="agent-valuation-button-homepage"
                    >
                        {agentValuationCta}
                    </AgentValuationButton>
                </MainContent>
            </Wrapper>
        </>
    );
};
